import { Console } from "console";
import { Permission } from "../entities/permission.entity";

export function hasPermission(
    permissions: Permission[] = [],
    resource?: string,
    action?: string
  ): boolean {
    if (!resource || !action) return true;
    return permissions.some(
      (p) =>
        (p.resource === resource || p.resource === '*') &&
        (p.action.includes(action) || p.action.includes('*'))
    );
  }
  